import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { CaseLockHttpService } from './case-lock-http.service';
import { QueueService } from './queue.service';
import { SettingsService } from './settings.service';
import { PersonInsuranceStateService } from '../state-services/insurance-state-service';
import { GlobalErrorHandler } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateInsuranceQueueService extends BaseService {

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService,
    private caseLockHttpService: CaseLockHttpService,
    private queueService: QueueService,
    private globalErrorHandler: GlobalErrorHandler,
    private insuranceStateService: PersonInsuranceStateService
  ) {
    super(settingsService);
  }

  actionSchedule() {
    if (!this.queueService.anyInsuranceQueuedOperationsRunning()) {
      return this.runActions();
    }
  }

  runActions() {
    this.queueService.insuranceQueuedOperationsRunning(true);

    const nextInsurance = this.queueService.popInsurance();
    if (nextInsurance == null) {
      return this.queueService.insuranceQueuedOperationsRunning(false);
    }

    return this.caseLockHttpService
      .put<any>(this.baseURL + 'insurances/' + nextInsurance.id, nextInsurance, { headers: this.jsonHeaders })
      .subscribe(() => {
        this.insuranceStateService.updateCacheAndEmitInsuranceUpdated(nextInsurance);
        this.runActions();
      }, err => {
        this.globalErrorHandler.handleError(err);
        this.runActions();
      });
  }
}
